import clsx from 'clsx';

import { Tooltip } from '../../../overlays/tooltip/Tooltip.js';
import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { charsFontWidth14pixelsSize500Map } from '../../core/components/text-ellipsis/chars-font-width-map.js';
import { truncateString } from '../../core/components/text-ellipsis/truncate-string.js';
import { dimmedLabel, interactiveLabel } from './SankeyLabelOverlay.sty.js';

/**
 * A single truncated node label wrapped in a tooltip. Shared by every label
 * zone so the truncation, tooltip, and dim/interactive class logic lives in one
 * place.
 */
export function SankeyNodeLabel({
  label: fullLabel,
  width,
  className,
  truncationMode,
  dimmed,
}: Readonly<{
  label: string;
  width: number;
  className: string;
  truncationMode: TruncationMode;
  dimmed: boolean;
}>) {
  const label = truncateString(
    fullLabel,
    width,
    charsFontWidth14pixelsSize500Map,
    truncationMode,
  );
  const isTruncated = label !== fullLabel;

  return (
    <Tooltip text={fullLabel} disabled={!isTruncated}>
      <span
        className={clsx(
          className,
          isTruncated && interactiveLabel,
          dimmed && dimmedLabel,
        )}
      >
        {label}
      </span>
    </Tooltip>
  );
}

SankeyNodeLabel['displayName'] = 'SankeyNodeLabel';
